import React, { Component } from 'react';
import { queryOrgCompanyList } from '@api/core/org';
import { queryDictExpend } from '@api/core/dict';

const MyContainer = WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expendType: [],
        company: [],
      };
    }

    componentDidMount() {
      this.loadExpendType();
      this.getOrgCompanyList();
    }

    loadExpendType = () => {
      queryDictExpend().then(res => {
        if (res.statusCode === 200) {
          this.setState({
            expendType: res.data,
          });
        }
      });
    };

    getOrgCompanyList = () => {
      queryOrgCompanyList({
        type: 1,
      }).then(res => {
        this.setState({
          company: res.data,
        });
      });
    };

    render() {
      const props = {
        ...this.props,
        expendType: this.state.expendType,
        company: this.state.company,
      };
      return <WrappedComponent {...props} />;
    }
  };
};

export default MyContainer;



// WEBPACK FOOTER //
// ./src/components/comm/DataWrapper.js